import { render } from "./ReceiverInformation.vue?vue&type=template&id=481ad1be"
import script from "./ReceiverInformation.vue?vue&type=script&lang=js"
export * from "./ReceiverInformation.vue?vue&type=script&lang=js"

import "./ReceiverInformation.vue?vue&type=style&index=0&id=481ad1be&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__